// extracted by mini-css-extract-plugin
export default {"form":"ViewPedidoBmaPonto_form__mf94r","areaBtn":"ViewPedidoBmaPonto_areaBtn__xxKaH","btn":"ViewPedidoBmaPonto_btn__uOdVp","btn2":"ViewPedidoBmaPonto_btn2__xy7vw"};